import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { ProtectedRoute } from "@/lib/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import VoterLogin from "@/pages/VoterLogin";
import AdminLogin from "@/pages/AdminLogin";
import VoterDashboard from "@/pages/VoterDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Explorer from "@/pages/Explorer";
import Results from "@/pages/Results";
import Audit from "@/pages/Audit";
import Privacy from "@/pages/Privacy";
import Features from "@/pages/Features";
import LearnMore from "@/pages/LearnMore";
import SiteFooter from "@/components/SiteFooter";
import UpdateBanner from "@/components/UpdateBanner";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import IdleTimeout from "@/components/IdleTimeout";

// Initial page is the Voter login. Authenticated users skip past it to their hub.
function RootRedirect() {
    const { user } = useAuth();
    if (user === null) return null; // still resolving session
    if (user && user.role === "admin") return <Navigate to="/admin" replace />;
    if (user && user.role === "voter") return <Navigate to="/vote" replace />;
    return <VoterLogin />;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <ImpersonationBanner />
                    <IdleTimeout />
                    <Routes>
                        <Route path="/" element={<RootRedirect />} />
                        <Route path="/about" element={<Landing />} />
                        <Route path="/login/voter" element={<VoterLogin />} />
                        <Route path="/login/admin" element={<AdminLogin />} />
                        <Route path="/explorer" element={<Explorer />} />
                        <Route path="/results" element={<Results />} />
                        <Route path="/results/:id" element={<Results />} />
                        <Route path="/audit" element={<Audit />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/features" element={<Features />} />
                        <Route path="/learn-more" element={<LearnMore />} />
                        <Route
                            path="/vote"
                            element={
                                <ProtectedRoute role="voter">
                                    <VoterDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute role="admin">
                                    <AdminDashboard />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                    <SiteFooter />
                    <UpdateBanner />
                </BrowserRouter>
                <Toaster richColors position="top-right" />
            </AuthProvider>
        </div>
    );
}

export default App;
